// DownloadExcel.js
import React from "react";
import ExcelJS from "exceljs";
import { withTranslation } from "react-i18next";

const DownloadExcel = ({ data, t }) => {
  const downloadAsExcel = async () => {
    // Create a new workbook and worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate().toString().padStart(2, "0")}/${(currentDate.getMonth() + 1).toString().padStart(2, "0")}/${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours().toString().padStart(2, "0")}:${currentDate.getMinutes().toString().padStart(2, "0")}:${currentDate.getSeconds().toString().padStart(2, "0")}`;
    const downloadDateTime = `${t("Route Supervisor Report Generated on")}: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(t("Route Supervisor"));

    // Define styles
    const boldFont = { bold: true };

    // Add downloadDateTime
    worksheet.addRow(["", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 5);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Add title row
    worksheet.addRow(["", t("Route Supervisor Details"), ""]);
    worksheet.mergeCells(2, 2, 2, 5);
    worksheet.getCell(2, 2).value = t("Route Supervisor Details");
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Add table header row
    const tableHeaderRow = worksheet.addRow([
      t("S.No"),
      t("Route Supervisor Name"),
      t("Mobile Number"),
      t("Email ID"),
      t("Status"),
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 5) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "003366" },
        };
      }
    });

    // Add data rows
    data.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.routeSupervisorName || "N/A",
        item.mobileNumber || "N/A",
        item.emailId || "N/A",
        item.status || "N/A",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 5) {
          cell.alignment = { horizontal: "left" };
        }
      });
    });

    // Set column widths
    worksheet.columns = [
      { width: 5 }, // S.No
      { width: 35 }, // Supervisor Name
      { width: 15 }, // Mobile Number
      { width: 25 }, // Email ID
      { width: 15 }, // Status
    ];

    // Save the workbook
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "RouteSupervisor.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <button className="btn btn-excel" onClick={downloadAsExcel}>
      <i className="fa-solid fa-file-excel me-1 icon-container"></i>
      {t("Excel")}
    </button>
  );
};

export default withTranslation()(DownloadExcel);